var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1114_5796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0C25.3137 2.57702e-07 28 2.68629 28 6V22C28 25.3137 25.3137 28 22 28H6C2.68629 28 3.22139e-08 25.3137 0 22V6C2.57711e-07 2.68629 2.68629 3.22128e-08 6 0H22ZM10.7559 7.01562C9.27268 7.23636 6.46182 6.86977 5.26367 7.83105C4.19337 8.69122 4.10908 11.1234 4.04688 12.4082C3.95898 14.2325 3.97227 16.2928 4.2959 18.0879C4.72325 20.4612 5.83152 20.6447 8.03906 20.8242C11.4 21.0975 14.9935 21.0037 18.3594 20.8682C19.6449 20.8161 21.7734 20.919 22.8018 20.085C23.9282 19.1713 23.9327 16.3705 23.9746 15.0137C24.0246 13.4089 24.0732 10.007 23.3818 8.60156C22.4009 6.60842 18.6544 7.2612 16.8301 7L10.7559 7.01562ZM17.2559 13.9805L11.9375 16.9648V10.9961L17.2559 13.9805Z",
    fill: "#FF0909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.756 7.01526L16.8305 7C18.6549 7.2612 22.4005 6.60819 23.3815 8.60133C24.073 10.0065 24.0243 13.4085 23.9743 15.0134C23.9323 16.3701 23.9287 19.1711 22.8022 20.0849C21.7739 20.9192 19.6453 20.816 18.3596 20.8681C14.9935 21.0036 11.3998 21.0978 8.03865 20.8245C5.8311 20.645 4.72305 20.4614 4.29569 18.0882C3.97202 16.2929 3.9585 14.2325 4.0464 12.4081C4.10861 11.1232 4.19336 8.69065 5.264 7.83074C6.46222 6.8694 9.27293 7.23607 10.756 7.01526ZM11.9376 16.9653L17.2561 13.9807L11.9376 10.9962V16.9653Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1114_5796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeImage);
export default __webpack_public_path__ + "static/media/youtube-image.3e3a55a30bb40d52dce23981738cc8e9.svg";
export { ForwardRef as ReactComponent };